import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon, Spin } from 'antd';

import ChangePasswordPopup from './components/ChangePasswordPopup/ChangePasswordPopup';
import appSettings from '../../constants/app.constants';

import './container.scss';
import AddEmailPopup from './components/AddEmailPopup/AddEmailPopup';
import ChangeEmailPopup from './components/ChangeEmailPopup/ChangeEmailPopup';
import DispexButton from '../../components/DispexButton/DispexButton';
import { userActions } from '../../actions/user.actions';

const Profile = () => {
  const dispatch = useDispatch();
  const [height, setHeight] = useState(0);
  const [loading, setLoading] = useState(false);
  const [changePasswordPopupOpened, setChangePasswordPopupOpened] =
    useState(false);
  const [addEmailPopupOpened, setAddEmailPopupOpened] = useState(false);
  const [changeEmailPopupOpened, setChangeEmailPopupOpened] = useState(false);
  const listener = useCallback(() => {
    setHeight(window.innerHeight - appSettings.windowHeightDelta);
  }, [window.innerHeight, appSettings.windowHeightDelta]);
  useEffect(() => {
    setHeight(window.innerHeight - appSettings.windowHeightDelta);
    window.addEventListener('resize', listener);

    return () => {
      window.removeEventListener('resize', listener);
    };
  }, [listener]);

  const { SurName, PatrName, FirstName, email, isEmailLoaded } = useSelector(
    (store) => store.authentication?.userInfo
  );
  const styleContainer = {
    height: height - 1,
  };

  const closeEmailPopup = useCallback(() => {
    setLoading(true);
    setAddEmailPopupOpened(false);
    dispatch(userActions.loadUserEmail());
    setLoading(false);
  }, []);

  const openEmailPopup = useCallback(() => setAddEmailPopupOpened(true), []);
  const openChangeEmailPopup = useCallback(
    () => setChangeEmailPopupOpened(true),
    []
  );
  const closeChangeEmailPopup = useCallback(() => {
    setLoading(true);
    setChangeEmailPopupOpened(false);
    dispatch(userActions.loadUserEmail());
    setLoading(false);
  }, []);
  const openChangePasswordPopup = useCallback(
    () => setChangePasswordPopupOpened(true),
    []
  );
  const closeChangePasswordPopup = useCallback(
    () => setChangePasswordPopupOpened(false),
    []
  );
  return (
    <Spin spinning={!isEmailLoaded || loading}>
      <div
        className="Profile_page"
        style={styleContainer}
      >
        <div className="left_side">
          <div className="row">
            <div className="col">
              <span className="field_name">Личные данные</span>
              {SurName && <span className="data">{SurName}</span>}
              {FirstName && <span className="data">{FirstName}</span>}
              {PatrName && <span className="data">{PatrName}</span>}
            </div>
            <div className="col">
              <div className="user_info_block">
                <span className="field_name">Контактные данные</span>
                <div className="contact_data">
                  <span className="data">
                    {email ? email : 'Данных пока нет'}
                  </span>
                  {email && (
                    <Button
                      className="edit_email_button"
                      shape="circle"
                      size="small"
                      title="Изменить почту"
                      aria-label="Изменить почту"
                      onClick={openChangeEmailPopup}
                    >
                      <Icon type="edit" />
                    </Button>
                  )}
                </div>
                {!email && (
                  <Button
                    className="button"
                    type="primary"
                    onClick={openEmailPopup}
                  >
                    Привязать почту
                  </Button>
                )}
                {addEmailPopupOpened && (
                  <AddEmailPopup onExit={closeEmailPopup} />
                )}
                {changeEmailPopupOpened && (
                  <ChangeEmailPopup onExit={closeChangeEmailPopup} />
                )}
              </div>

              <DispexButton
                className="button"
                type="primary"
                onClick={openChangePasswordPopup}
              >
                Изменить пароль
              </DispexButton>
              {changePasswordPopupOpened && (
                <ChangePasswordPopup onExit={closeChangePasswordPopup} />
              )}
            </div>
          </div>
        </div>
        <div className="right_side">
          <div className="ornament_container">
            <div className="ornament_part ornament_part-first"></div>
            <div className="ornament_part ornament_part-second"></div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default Profile;
